import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { RteDialogRef } from 'rte-library';
import { FileExtensionEnum } from '../enums/file-extension.enum';
import { ReportExportionSettings } from './report-exportation-settings.model';

@Component({
  selector: 'app-report-exportation-settings-dialog',
  templateUrl: './report-exportation-settings-dialog.component.html',
  styleUrls: ['./report-exportation-settings-dialog.component.scss']
})
export class ReportExportationSettingsDialogComponent implements OnInit {

  confirm: EventEmitter<ReportExportionSettings> = new EventEmitter<ReportExportionSettings>();

  constructor(
    public dialogRef: RteDialogRef<ReportExportationSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportExportionSettings) { }

  ngOnInit() {
    this.verifyCompressFile();
    this.verifyDelimiter();
  }

  closeDialog(){
    this.dialogRef.close();
  }

  onExtensionChange(){
    this.verifyCompressFile();
    this.verifyDelimiter();
  }

  onConfirm(){
    this.confirm.emit(this.data);
    this.closeDialog();
  }

  verifyCompressFile(){
    this.data.CompressFile = this.isTextExtension;
  }

  verifyDelimiter(){
    if (this.canEditDelimiter) {
      this.data.Delimiter = ';';
    } else {
      this.data.Delimiter = '';
    }
  }

  get canEditDelimiter() : boolean{
    return this.isCsvExtension || this.isTextExtension;
  }

  get canEditCompressOption() : boolean {
    return !this.isTextExtension;
  }

  get isTextExtension() : boolean {
    return this.data.Extension == FileExtensionEnum.TXT;
  }

  get isCsvExtension() : boolean {
    return this.data.Extension == FileExtensionEnum.CSV;
  }

}
